import React, { PureComponent } from 'react';

import ModalContainer from '@bit/wavfichacerta.fichacerta.modals.modal-container';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { Container, SpanTitle, GrayText } from '../form/fieldModal/formModalFields.styled';
import { ModalFooterPrimaryButton } from '../../../../components/shared/modal/modalFooterPillButtons';

const MAX_EDICOES_LAUDO = 30;

/** contador_edicao na API = créditos restantes (30 → 0), não “edições já feitas”. */
function parseCreditosRestantes(raw) {
  const n = Number(raw);
  return Number.isFinite(n) ? n : NaN;
}

class EditsCountModal extends PureComponent {

  renderFooter = () => {
    const creditos = parseCreditosRestantes(this.props.count);
    const podeContinuar = Number.isFinite(creditos) && creditos > 0;
    return (
      <StyledRow padding='0 3em' justify="center">
        <ModalFooterPrimaryButton data-testid="go-back-button" onClick={this.onSubmit}>
          {podeContinuar ? 'Continuar' : 'Fechar'}
        </ModalFooterPrimaryButton>
      </StyledRow>
    );
  }

  renderHeader = () => (
    <SpanTitle customstyle="margin: auto;">
      ATENÇÃO
    </SpanTitle>
  )

  onSubmit = () => {
    const creditos = parseCreditosRestantes(this.props.count);
    if (Number.isFinite(creditos) && creditos > 0) {
      this.props.continue(false);
    } else {
      this.props.closeModal();
    }
  }

  render() {
    const creditos = parseCreditosRestantes(this.props.count);
    const ordinalProxima = Number.isFinite(creditos) ? MAX_EDICOES_LAUDO + 1 - creditos : null;

    let body;
    if (!Number.isFinite(creditos)) {
      body = (
        <div>
          <span>Não foi possível carregar o número de edições disponíveis para esta solicitação.</span>
          <br /><br />
          <span>Atualize a página (F5). Se o problema continuar, entre em contato com o suporte.</span>
        </div>
      );
    } else if (creditos > 0) {
      body = (
        <div>
          <span>
            Essa será a {ordinalProxima}ª de {MAX_EDICOES_LAUDO} alterações de dados do laudo possíveis.
          </span>
          <br /><br />
          <span>
            Após a {MAX_EDICOES_LAUDO}ª alteração, será necessário solicitar uma RECONSULTA, ou um novo produto.
          </span>
        </div>
      );
    } else {
      body = (
        <div>
          <span>
            Não há mais edições de laudo disponíveis para esta solicitação (limite de {MAX_EDICOES_LAUDO} alterações
            atingido). Não é possível fazer novas edições.
          </span>
          <br /><br />
          <span>Para realizar novas edições será necessário solicitar uma RECONSULTA, ou um novo produto.</span>
        </div>
      );
    }

    return (
      <ModalContainer
        isOpen={this.props.isOpen}
        size="sm"
        onClose={this.props.closeModal}
        footer={this.renderFooter()}
        header={this.renderHeader()}
      >

        <Container customstyle="text-align: center; margin: 20px auto;">
          <GrayText>{body}</GrayText>
        </Container>

      </ModalContainer>
    );
  }
}

export default EditsCountModal;